import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";
import InputMediaCard from "../../ui-elements/inputCards";
import { Solar, Battery, SmartHouse } from "../../../resources/images/calculator/svgImages";
import RatingSlider from "../../ui-elements/ratingSlider";
import UseDebounce from "../../../resources/Debounce";
import { Utils } from "../../../resources/util";

const commingSoon = require("../../../resources/images/comming-soon.png");

export default function UserInputs(props) {
  const classes = useStyles();
  const [values, setValues] = useState({
    items: [],
    deposit: 0
  });
  const min = props.sliderProps.min;
  const max = props.totalCost ? parseInt(props.totalCost) : props.sliderProps.max;
  const amountInArray = props.totalCost ? props.totalCost.split(".") : [];
  const cents = amountInArray.length !== 0 && amountInArray[1];
  let defaultVal = props.sliderProps.default;
  const marks = props.sliderProps.marks && props.sliderProps.marks;
  const step = props.sliderProps.step;
  const items = [
    {
      value: "solar",
      label: "Solar",
      icon: <Solar cardImage={`${classes.cardImage} ${values.items.includes("solar") && classes.cardImageActive}`} />
    },
    {
      value: "battery",
      label: "Battery",
      icon: <Battery cardImage={`${classes.cardImage} ${values.items.includes("battery") && classes.cardImageActive}`} />
    },
    {
      value: "smartHome",
      label: "Smart Home",
      icon: <SmartHouse cardImage={`${classes.cardImage} ${values.items.includes("smartHome") && classes.cardImageActive}`} />
    }
  ];
  const deBounceVal = UseDebounce(values, 500);

  useEffect(() => {
    const deposit = cents ? values.deposit + "." + cents : values.deposit;
    props.userBenefitsCalc(values.items, deposit);
    // eslint-disable-next-line
  }, [deBounceVal]);

  const onSelectItems = value => {
    const newCount = values.items;
    if (newCount.includes(value)) {
      newCount.splice(newCount.indexOf(value), 1);
      value === "solar" && newCount.splice(newCount.indexOf("battery"), 1);
    } else {
      value === "solar" ? newCount.unshift(value) : newCount.push(value);
    }
    setValues({
      ...values,
      items: newCount,
      deposit: 0
    });
    props.selectItems(newCount);
  };

  const sliderOnChange = value => {
    setValues({
      ...values,
      deposit: value
    });
    props.setDepositAmount(value);
  };

  return (
    <Grid className={classes.root} container direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
      <Grid item xs={12} className={classes.section}>
        <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
          <Grid item xs={12} className={classes.headerTitles}>
            <Typography variant="h6" component="h6">
              I&apos;d like to add
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              {items.map((valueObj, index) => (
                <Grid key={index} item>
                  <InputMediaCard
                    icon={valueObj.icon}
                    title={valueObj.label}
                    cardInput={classes.itemCards}
                    class={classes.user1}
                    onClick={() => onSelectItems(valueObj.value)}
                    selected={values.items.includes(valueObj.value)}
                    disabled={valueObj.value === "smartHome" || (!values.items.includes("solar") && valueObj.value === "battery")}
                    labelImg={items.length - 1 === index && <img src={commingSoon} alt="" />}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {values.items && values.items.length !== 0 && (
        <Grid item xs={12} className={`${classes.section} ${classes.endCalc}`}>
          <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
            <Grid item xs={12} className={classes.headerTitles}>
              <Typography variant="h6" component="h6">
                Deposit
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.sliderWrapper}>
              <RatingSlider
                marks={marks}
                min={min}
                max={max}
                step={step}
                default={defaultVal}
                value={values.deposit}
                sliderOnChange={sliderOnChange}
                labelStart={"$0"}
                labelEnd={`$${Utils.formatCurrency(max)}`}
                valueLabel={"on"}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

UserInputs.propTypes = {
  setPostal: PropTypes.func,
  sliderProps: PropTypes.object,
  postalCode: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  averageBillCal: PropTypes.func,
  estimatedAnnualBill: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  didMound: PropTypes.bool,
  selectItems: PropTypes.func,
  setDepositAmount: PropTypes.func,
  totalCost: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  userBenefitsCalc: PropTypes.func,
  userDepositAmount: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  selectedItems: PropTypes.array
};
